<!--
 * @Description: 我的网络课程
 * @Author: PF
 * @Date: 2023-10-08 10:29:32
 * @LastEditors: PF
 * @LastEditTime: 2025-12-01 16:07:37
-->
<template>
  <el-dialog class="wp90 hp90" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
    <template #header>
      <div class="header-left">
        <el-icon class="header-icon">
          <List />
        </el-icon>
        <span class="header-title">我的网络课程</span>
      </div>
      <div class="header-right"> 
        <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
          <el-icon>
            <Close />
          </el-icon>
        </el-button>
      </div>
    </template>
    <div class="list-page pl0 pr0 pt0 pb0">
      <el-container>
        <el-header>
          <!-- 搜索区域 BEGIN -->
          <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
            <el-form-item>
              <el-input placeholder="网络课程名称" v-model="dataGrid.parms.wlkcmc" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                <template #suffix>
                  <el-icon class="el-input__icon pointer" @click="bindTable()">
                    <search />
                  </el-icon>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="所属专业" v-model="dataGrid.parms.zyid" clearable filterable @change="bindTable()">
                <el-option v-for="item in zyData" :key="item.id" :label="item.zymc" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="教务课程" v-model="dataGrid.parms.kcid" clearable filterable @change="bindTable()">
                <el-option v-for="item in kcData" :key="item.id" :label="item.kcmc" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="状态" v-model="dataGrid.parms.zt" clearable filterable @change="bindTable()">
                <el-option v-for="(item,index) in wlkcztData.list" :key="index" :label="item.name" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <!-- 搜索区域 END -->
          <!-- 按钮区域 BEGIN -->
          <div class="button-box">
            <el-button type="primary" @click="openAdd=true"><span class="iconfont icon-chuangjian"></span>添加</el-button>
            <el-button type="primary" @click="tiJiaoShenHeClick()">批量提交审核</el-button>
            <el-button type="primary" @click="cheXiaoTiJiaoClick()">批量撤销审核</el-button>
            <el-button type="warning" @click="remove()"><span class="iconfont icon-shanchu"></span>批量删除</el-button>
            <el-button type="primary" @click="openBangZhu=true">? 帮助说明</el-button>
          </div>
          <!-- 按钮区域 END -->
        </el-header>
        <el-main>
          <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
            <!-- 冻结列-Left BEGIN -->
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column label="序号" type="index" width="80" fixed align="center" />
            <!-- 冻结列-Left END -->
            <el-table-column label="网络课程名称" prop="wlkcmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="关键字" prop="gjz" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="状态" prop="zt" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
              <template #default="scope">
                <span v-for="(item, index) in ztData.list" :key="index">
                  <span v-if="scope.row.zt === item.value">{{ item.label}}</span>
                </span>
              </template>
            </el-table-column>
            <!-- 冻结列-Right BEGIN -->
            <el-table-column label="操作" width="230" fixed="right" align="center">
              <template #default="scope">
                <el-button v-if="scope.row.zt === ztData.siyou" link type="primary" @click="dataGrid.multipleSelection=[scope.row.id]; tiJiaoShenHeClick(scope.row)">提交审核</el-button>
                <el-button v-if="scope.row.zt === ztData.daishenhe" link type="primary" @click="dataGrid.multipleSelection=[scope.row.id]; cheXiaoTiJiaoClick(scope.row)">撤销提交</el-button>
                <el-button link type="success" @click="openDetail=true; row=scope.row">详情</el-button>
                <el-button link type="primary" @click="openEdit=true; row=scope.row">修改</el-button>
                <el-button link type="warning" @click="dataGrid.multipleSelection=[scope.row.id]; remove()">删除</el-button>
              </template>
            </el-table-column>
            <!-- 冻结列-Right END -->
          </el-table>
        </el-main>
        <el-footer>
          <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
        </el-footer>
      </el-container>
    </div>
  </el-dialog>
  <add v-if="openAdd" v-model:openAdd="openAdd" @ReturnData="bindTable()" />
  <edit v-if="openEdit" v-model:openEdit="openEdit" :row="row" @ReturnData="bindTable()" />
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
  <bangzhushuoming v-if="openBangZhu" v-model:openDetail="openBangZhu" />
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import {
  loadList,
  submitDataGridAction,
  actionPost,
  loadSelect,
  homeCloseWindow
} from '@/api/common.js'
import pagination from '@/components/pagination.vue'
import { warningPrompt, successPrompt } from '@/utils/promptInfo'
import { getWlkczt } from '@/utils/meiju'
import add from './add.vue'
import edit from './edit.vue'
import detail from './detail.vue'
import bangzhushuoming from '@/components/bangzhu/bangzhushuoming.vue'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

// 加载网络课程状态下拉框
const wlkcztData = ref({ list: [] })
loadSelect({
  url: '/api/v2/wangluojiaoxue/wangluokecheng/wangluokechengzhuangtai',
  data: wlkcztData
})
// 加载网络教学专业下拉框
const zyData = ref()
loadSelect({
  url: '/api/v2/wangluojiaoxue/ziyuanku/zhuanyelist',
  data: zyData,
  order: 'zymc',
  sort: 'asc'
})
// 加载网络教学课程下拉框
const kcData = ref()
loadSelect({
  url: '/api/v2/wangluojiaoxue/wangluojiaoxuekecheng/list',
  data: kcData,
  order: 'kcmc',
  sort: 'asc'
})
const ztData = ref(getWlkczt())

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'wlkcmc', order: 'ascending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  dataGrid.value.parms.wlkcmc = dataGrid.value.parms.wlkcmc || null
  dataGrid.value.parms.kcid = dataGrid.value.parms.kcid || null
  dataGrid.value.parms.zt = dataGrid.value.parms.zt || null
  dataGrid.value.parms.zyid = dataGrid.value.parms.zyid || null
  loadList({
    url: '/api/v2/wangluojiaoxue/wangluokecheng/my',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function (res) {
      dataGrid.value.multipleSelection = []
    }
  })
}

// 弹窗
const row = ref()
const openBangZhu = ref(false)
const openAdd = ref(false)
const openEdit = ref(false)
const openDetail = ref(false)
const openList = ref(false)
watch(
  () => props.open,
  () => {
    if (props.open === 'wodewangluokecheng') {
      openList.value = true
      bindTable()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)

// 提交审核
const tiJiaoShenHeClick = () => {
  if (dataGrid.value.multipleSelection.length === 0) {
    return warningPrompt('请选择网络课程')
  }
  const options = { url: '/api/v2/wangluojiaoxue/wangluokecheng/tijiaoshenhe', data: { wlkcids: dataGrid.value.multipleSelection, menuId: sessionStorage.getItem('menuId') } }
  actionPost(options).then((res) => {
    if (res.code === 200) {
      bindTable()
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
// 撤销提交
const cheXiaoTiJiaoClick = () => {
  if (dataGrid.value.multipleSelection.length === 0) {
    return warningPrompt('请选择网络课程')
  }
  const options = { url: '/api/v2/wangluojiaoxue/wangluokecheng/chexiaoshenhe', data: { wlkcids: dataGrid.value.multipleSelection, menuId: sessionStorage.getItem('menuId') } }
  actionPost(options).then((res) => {
    if (res.code === 200) {
      bindTable()
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
// 删除
const remove = async () => {
  submitDataGridAction({
    url: '/api/v2/wangluojiaoxue/wangluokecheng',
    dataGrid: dataGrid.value,
    confirmTitle: '确定要删除吗?',
    method: 'delete',
    callback: function (res) {
      bindTable()
    }
  })
}
</script>
<style lang="less" scoped>
</style>
